import { GrFormClose } from 'react-icons/gr'
import {
  Container,
  Header,
  Content,
  TextIcons,
  ShortCutNumber,
  ShortCutLetter,
  NavigationQuestion,
  OtherCourses,
  ResolutionQuestion,
  Resource,
} from './styles'
import { FiArrowRight, FiArrowLeft } from 'react-icons/fi'
import Modal from 'pages/MyQuestionBooks/components/Modal'

interface IProps {
  isOpen: boolean
  onClose(): void
}

const CreateQuestionBookModal = (props: IProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <Header>
          <h1>Lista das teclas de atalho</h1>
          <button className="close" onClick={props.onClose}>
            <GrFormClose size="100%" />
          </button>
        </Header>
        <Content>
          <NavigationQuestion>
            <h2>Navegação nas questões:</h2>
            <TextIcons>
              Questão seguinte:{' '}
              <ShortCutNumber className="nextQuestion">
                <FiArrowRight size={20} />
              </ShortCutNumber>{' '}
              ou
              <ShortCutLetter>NumPad 6</ShortCutLetter>
            </TextIcons>
            <TextIcons>
              Questão anterior:{' '}
              <ShortCutNumber className="previusQuestion">
                <FiArrowLeft size={20} />
              </ShortCutNumber>{' '}
              ou
              <ShortCutLetter>NumPad 4</ShortCutLetter>
            </TextIcons>
            <TextIcons>
              *Próxima questão não resolvida: <ShortCutNumber>N</ShortCutNumber>
            </TextIcons>
          </NavigationQuestion>
          <OtherCourses>
            <h2>Demais recursos:</h2>
            <TextIcons>
              *Ativa/Desativa tela cheia: <ShortCutNumber>F</ShortCutNumber>{' '}
            </TextIcons>
            <TextIcons>
              Ativa/Desativa assunto: <ShortCutNumber className="activateSubject">I</ShortCutNumber>{' '}
            </TextIcons>
            <TextIcons className="previusQuestion">
              Ativa/Desativa modo escuro: <ShortCutNumber>K</ShortCutNumber>
            </TextIcons>
          </OtherCourses>
        </Content>
        <ResolutionQuestion>
          <div>
            <h2>Resolução de questões:</h2>
            <TextIcons className="nextQuestion">
              Selecionar alternativas (múltipla escolha): <ShortCutNumber>1</ShortCutNumber>
              {','}
              <ShortCutNumber>2</ShortCutNumber>, <ShortCutNumber>3</ShortCutNumber> ,
              <ShortCutNumber>4</ShortCutNumber>, <ShortCutNumber>5</ShortCutNumber>
            </TextIcons>
            <TextIcons className="previusQuestion">
              Selecionar alternativas (certo ou errado): <ShortCutNumber>1</ShortCutNumber> ,
              <ShortCutNumber>2</ShortCutNumber> ou <ShortCutNumber>C</ShortCutNumber>,{' '}
              <ShortCutNumber>E</ShortCutNumber>{' '}
            </TextIcons>
            <TextIcons className="previusQuestion">
              Resolver questão: <ShortCutLetter>Enter</ShortCutLetter>
            </TextIcons>
          </div>
        </ResolutionQuestion>
        <Resource>* Recurso exclusivo para caderno</Resource>
      </Container>
    </Modal>
  )
}

export default CreateQuestionBookModal
